export default __webpack_public_path__ + "static/7Churches-69c5797666706e4d13de516b09ec2dac.jpg";